export default [
  {
    path: 'auth',
    component: () => import( /* webpackChunkName: "auth" */ '@/views/common/auth/Auth.vue'),
    children: [{
        path: '/sign-in',
        name: 'sign-in',
        component: () => import( /* webpackChunkName: "auth" */ '@/views/common/auth/SignIn.vue')
      },
      {
        path: '/sign-up',
        name: 'sign-up',
        component: () => import( /* webpackChunkName: "auth" */ '@/views/common/auth/SignUp.vue')
      },
      {
        path: '/forgot',
        name: 'forgot',
        component: () => import( /* webpackChunkName: "auth" */ '@/views/common/auth/ForgotPassword.vue')
      },
      {
        path: '/change-password',
        name: 'change-password',
        component: () => import( /* webpackChunkName: "auth" */ '@/views/common/auth/ChangePassword.vue'),
        props: (route) => ({
          email: route.query.email
        }),
      },
      {
        path: '/confirm',
        props: (route) => ({
          email: route.query.email
        }),
        name: 'confirm',
        component: () => import( /* webpackChunkName: "auth" */ '@/views/common/auth/Confirm.vue')
      },
    ]
  },
]
